<template>
    <div>
      修改邮箱
  </div>
  </template>
  
  <script>
  export default {
    data () {
      return {
   
      }
    }
  }
  </script>
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/components/ChangeEmail.vue